// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectWeightMetersInitWaitingMessage, selectWeightMetersInStore, selectWeightMetersPageLoading } from '../_selectors/weight-meter.selectors';

export class WeightMetersDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectWeightMetersPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectWeightMetersInitWaitingMessage)
		);

		this.store.pipe(
			select(selectWeightMetersInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
